import { dateTimeParser } from '@/utils/helpersDate'
import { CommunicationLogsData } from '../../../TelemedicineServices.types'

class CommunicationLogsDataMapper {
  toDomain(persistenceCommunicationLogData: CommunicationLogsData) {
    return {
      id: persistenceCommunicationLogData?.id,
      contactType:
        persistenceCommunicationLogData?.celular ||
        persistenceCommunicationLogData?.phone ||
        persistenceCommunicationLogData?.email,
      contactInfo:
        persistenceCommunicationLogData?.template ||
        persistenceCommunicationLogData?.mensagem ||
        persistenceCommunicationLogData?.message ||
        persistenceCommunicationLogData?.assunto,
      date: dateTimeParser(persistenceCommunicationLogData?.dataHora)?.date,
      hour: dateTimeParser(persistenceCommunicationLogData?.dataHora)?.time,
    }
  }
}

export default new CommunicationLogsDataMapper()
